export const now = (): number => Date.now();
